import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { CredentialType } from 'enums/CredentialType';
import { TaskAreaModel } from 'models/generated/Entities.GormCrm.TaskArea';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { TaskService } from 'services/task.service';

@Component({
	selector: 'edit-task-area',
	templateUrl: './edit-task-area.component.html',
	providers: [FormValidationService],
	imports: [DataTableComponent, DataRowComponent, CustomInputComponent, SubmitButtonComponent, TranslatePipe]
})
@CredentialRequired(CredentialType.UsersAccessFull)
export class EditTaskAreaComponent {

	@ViewChild('submitButton') submitButton!: SubmitButtonComponent;
	@Input() taskArea!: TaskAreaModel;
	@Output() savedTaskArea = new EventEmitter<TaskAreaModel>();

	constructor(private readonly taskService: TaskService) { }

	saveTaskArea() {
		this.taskService.createOrUpdateTaskArea(this.taskArea).then((newTaskArea) => {
			this.savedTaskArea.emit(newTaskArea);
			this.submitButton.succeeded();
		});
	}

}
